import Link from 'next/link';
import { IoChevronForward, IoDocumentTextOutline, IoImageOutline, IoPlayCircleOutline } from 'react-icons/io5';

import { Box, Stack, Text } from '@mantine/core';

import { Collateral } from 'models';
import { CollateralGroup, CollateralHelpers } from 'helpers/CollateralHelpers';

import { CollateralCover } from 'components/collateral/CollateralCover';

import cx from './CollateralTeaser.module.scss';

const CollateralTeaser = ({
    collateral,
    href,
    layout = 'horizontal',
}: {
    collateral: Collateral;
    href: string;
    layout?: 'horizontal' | 'vertical';
}) => (
    <Link href={href} className={cx.root} data-layout={layout}>
        <Box className={cx.tray} data-shape={CollateralHelpers.isPlayable(collateral) ? 'landscape' : 'portrait'}>
            <Box className={cx.cover}>
                <CollateralCover collateral={collateral} width={320} alt={collateral.title} iconSize={32} />
            </Box>
        </Box>

        <Stack gap={4} className={cx.content}>
            <Box className={cx.eyebrow}>
                {
                    {
                        [CollateralGroup.DOCUMENTS]: <IoDocumentTextOutline />,
                        [CollateralGroup.VIDEOS]: <IoPlayCircleOutline />,
                        [CollateralGroup.IMAGES]: <IoImageOutline />,
                    }[CollateralHelpers.group(collateral)]
                }
                <Text component="span" className={cx.eyebrowText}>
                    {CollateralHelpers.typeLabel(collateral)}
                </Text>
            </Box>
            <Text fw={700} lh={1.25} lineClamp={2} className={cx.title}>
                {collateral.title}
            </Text>
            {layout === 'horizontal' && collateral.description && (
                <Text lineClamp={2} className={cx.description}>
                    {collateral.description}
                </Text>
            )}
            <Text className={cx.cta}>
                Open
                <IoChevronForward />
            </Text>
        </Stack>
    </Link>
);

export { CollateralTeaser };
